export default "__VITE_ASSET__CMbYF0j2__"